<script setup lang="ts">
import { computed, inject, onMounted, ref, type Ref } from 'vue'
import type { Quiz } from '@/core/domain/quiz/Quiz.ts'
import ContentQuizView from '@/presentation/components/content/CContentQuizView.vue'

const dialogRef: any = inject('dialogRef')
const quiz: Ref<Quiz | null> = ref(null)
const subtitle: Ref<string> = ref('')

onMounted(() => {
  quiz.value = dialogRef.value?.data?.quiz
  subtitle.value = dialogRef.value?.data?.subtitle
})

const activeVersion = computed(() => {
  return quiz.value?.activeVersion
})

</script>

<template>
  <div class="flex flex-col justify-start gap-4" v-if="!activeVersion">
    <p>Aucun Quiz disponible</p>
  </div>
  <content-quiz-view v-else :subtitle="subtitle" :quiz-version="activeVersion" />
</template>

<style scoped>
:global(.p-dialog-header) {
  color: var(--bo-primary);
}

:global(.p-dialog-content) {
  color: var(--bo-primary);
}
</style>
